module.exports = __webpack_public_path__ + "static/media/payment-virement-bancaire.e037af19.png";